import React, { useState } from 'react';
import { PenTool, Ruler, Scissors, Truck, CalendarCheck, ListChecks, MapPin, WashingMachine, Shirt } from 'lucide-react';
import { seamlessTabs } from '../../mock';

const iconMap = { PenTool, Ruler, Scissors, Truck, CalendarCheck, ListChecks, MapPin, WashingMachine, Shirt };
const tabs = Object.keys(seamlessTabs);

export default function SeamlessCare() {
  const [active, setActive] = useState(tabs[0]);
  const steps = seamlessTabs[active];

  return (
    <section id="seamless" className="py-16 md:py-24 bg-gradient-to-b from-white to-pink-50/40">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="zp-section-title">
            Seamless Care, <span className="zp-gradient-text">Every Step</span>
          </h2>
          <p className="mt-4 text-slate-600">Select your service and see how we bring convenience to your doorstep.</p>
        </div>

        {/* Tabs */}
        <div className="mt-10 flex flex-wrap justify-center gap-2 border-b border-pink-100 max-w-3xl mx-auto">
          {tabs.map(t => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className={`relative px-5 py-3 font-semibold text-sm transition-colors ${active === t ? 'text-[#E91E80]' : 'text-slate-500 hover:text-slate-800'}`}
            >
              {t}
              {active === t && <span className="absolute left-2 right-2 -bottom-px h-0.5 bg-[#E91E80] rounded-full" />}
            </button>
          ))}
        </div>

        {/* Steps */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-4 gap-6">
          {steps.map((s, i) => {
            const Icon = iconMap[s.icon] || Truck;
            return (
              <div key={s.title} className="relative">
                <div className="zp-card p-6 h-full text-center">
                  <div className="h-14 w-14 mx-auto rounded-full bg-pink-50 text-[#E91E80] grid place-items-center">
                    <Icon size={24} />
                  </div>
                  <div className="mt-4 font-bold text-slate-900">
                    <span className="text-[#E91E80]">{i + 1}. </span>{s.title}
                  </div>
                  <p className="mt-1.5 text-sm text-slate-500">{s.desc}</p>
                </div>
                {i < steps.length - 1 && (
                  <div className="hidden md:block absolute top-10 -right-3 w-6 dashed-arrow" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
